<div style="background-color: #fff; padding: 20px;">
  <h1 mat-dialog-title style="color:#000;">{{ 'Category' | translate }}</h1>

  <div mat-dialog-content>

    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner></mat-spinner>
    </div>

    <form [formGroup]="productForm" (ngSubmit)="onSubmit()">

      <!-- Title Field -->
      <div class="form-group">
        <label for="title">{{ 'Title' | translate }}*</label>
        <input id="title" type="text" class="form-control" formControlName="title" [placeholder]="'Enter a title' | translate" />
      </div>

      <!-- Position Field -->
      <div class="form-group">
        <label for="position">{{ 'Position in the list' | translate }}</label>
        <input id="position" type="number" class="form-control" formControlName="position" [placeholder]="'e.g. 10' | translate" />
      </div>

      <!-- Category Image -->
      <div class="form-group">
        <label for="image">{{ 'Category image' | translate }}</label>
        <input id="image" type="file" class="form-control" formControlName="image" (change)="onFileChange($event)" />
      </div>

      <!-- Horizontal Background -->
      <div class="form-group">
        <label for="bgh">{{ 'Horizontal category background' | translate }}</label>
        <input id="bgh" type="file" class="form-control" formControlName="bgh" (change)="onFileChangeh($event)" />
      </div>

      <!-- Vertical Background -->
      <div class="form-group">
        <label for="bgv">{{ 'Vertical category background' | translate }}</label>
        <input id="bgv" type="file" class="form-control" formControlName="bgv" (change)="onFileChangev($event)" />
      </div>

    </form>
  </div>

  <!-- Footer -->
  <div mat-dialog-actions style="justify-content: flex-end; padding-right:20px; margin-bottom:0;">
    <button mat-raised-button color="secondary" type="button" *ngIf="productForm?.get('id')?.value" (click)="deleteProduct()">
      {{ 'Delete category' | translate }}
    </button>

    <button mat-raised-button color="primary" type="button" [disabled]="productForm?.invalid" (click)="onSubmit()">
      {{ 'Update category' | translate }}
    </button>
  </div>
</div>
